import { useContext } from 'react';

import { ListContext } from '@contexts/ListContext';
import { UserContext } from '@contexts/UserContext';

const useNetworkAgencies = (accountingGroupId, available) => {
    const { cachedList } = useContext(ListContext);
    const { currentUser } = useContext(UserContext);

    const returnObject = [];

    const availableNetworkAgencies = currentUser.NetworkAgencies;
    const availableAccountingGroups = currentUser.AccountingGroups;
    for (const accountingGroup of cachedList.accountingGroups.items) {
        if (
            (!available || availableAccountingGroups.includes(accountingGroup.ID)) &&
            (!accountingGroupId || accountingGroupId === accountingGroup.ID)
        ) {
            for (const networkAgency of accountingGroup.NetworkAgencies) {
                if (!available || availableNetworkAgencies.includes(networkAgency.ID)) {
                    returnObject.push({
                        ...networkAgency,
                        accountingGroupId: accountingGroup.ID,
                        accountingGroupName: accountingGroup.Name,
                    });
                }
            }
        }
    }
    return returnObject;
};

export default useNetworkAgencies;
